import React, { useState } from 'react';
import { login } from '../services/api';
import { FiArrowRight, FiEye, FiEyeOff, FiLock, FiMail } from 'react-icons/fi';
import { useNotification } from '../context/NotificationContext';
import '../styles/LoginPage.css';

function LoginPage({ onLogin }) {
  const { notify } = useNotification();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const nextErrors = {};

    if (!email.trim()) {
      nextErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      nextErrors.email = 'Enter a valid email address';
    }

    if (!password) {
      nextErrors.password = 'Password is required';
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const getErrorMessage = (error) => {
    const apiMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.response?.data?.errors?.[0]?.message;

    return apiMessage || 'Unable to sign in. Please check your credentials and try again.';
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await login({
        email: email.trim(),
        password,
      });

      onLogin(response);
    } catch (error) {
      notify(getErrorMessage(error), 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  /*const handleForgotPassword = () => {
    if (!email.trim()) {
      setErrors((current) => ({
        ...current,
        email: 'Enter your email first to reset your password',
      }));
      notify('Add your email address to reset the password', 'info');
      return;
    }

    notify(`Password reset link sent to ${email.trim()}`, 'success');
  };*/

  return (
    <div className="login-page">
      <div className="login-page__panel login-page__panel--brand">
        <div className="login-page__brand-copy">
          <span className="login-page__eyebrow">Backup Deploy System</span>
          <h1>Keep your backup operations secure, visible, and easy to manage.</h1>
          <p>
            Sign in to monitor servers, review jobs, and manage deployment settings from one place.
          </p>
        </div>

       
      </div>

      <div className="login-page__panel login-page__panel--form">
        <div className="login-card">
          <div className="login-card__header">
            <span className="login-card__badge">Welcome back</span>
            <h2>Log in to your account</h2>
            <p>Use your email and password to access the dashboard.</p>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-form__group">
              <label htmlFor="email">Email</label>
              <div className={`login-input ${errors.email ? 'login-input--error' : ''}`}>
                <FiMail />
                <input
                  id="email"
                  type="email"
                  placeholder="admin@company.com"
                  value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                    if (errors.email) {
                      setErrors((current) => ({ ...current, email: undefined }));
                    }
                  }}
                />
              </div>
              {errors.email && <p className="login-form__error">{errors.email}</p>}
            </div>

            <div className="login-form__group">
              <div className="login-form__label-row">
                <label htmlFor="password">Password</label>
               {/* <button
                  className="login-form__link"
                  type="button"
                  onClick={handleForgotPassword}
                >
                  Forgot password?
                </button>*/}
              </div>

              <div className={`login-input ${errors.password ? 'login-input--error' : ''}`}>
                <FiLock />
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    if (errors.password) {
                      setErrors((current) => ({ ...current, password: undefined }));
                    }
                  }}
                />
                <button
                  className="login-input__toggle"
                  type="button"
                  onClick={() => setShowPassword((current) => !current)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
              {errors.password && <p className="login-form__error">{errors.password}</p>}
            </div>

            <button className="btn btn-primary btn-lg btn-block login-form__submit" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Signing in...' : 'Log In'}
              {!isSubmitting && <FiArrowRight />}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
